<template>
  <div class="lv-item-box">
    <div class="title-box">
      <p v-if="hasTip" :class="type | tipsClassFilter">
        {{ type | tipsFilter }}
      </p>
      <h3 v-html="title"></h3>
    </div>
    <div
      v-show="artSummary"
      class="lv-item-artSummary"
      v-html="artSummary"
    ></div>
    <div class="lv-item-content">
      <span class="lv-item-author" v-show="author || otherAuthor">
        <span class="author" v-html="(author || '') + otherAuthor"></span>
        <!-- <span v-show="otherAuthor" v-html="otherAuthor"></span> -->
      </span>
      <span class="lv-item-periodicalName" v-html="periodicalName"></span>
      <span class="lv-item-periodicalTime" v-html="periodicalTime"></span>
    </div>
  </div>
</template>

<script>
export default {
  // 论文类型 0-期刊论文 1-会议论文 标题 摘要 作者 刊名 刊期
  props: [
    "hasTip",
    "type",
    "title",
    "artSummary",
    "author",
    "otherAuthor",
    "periodicalName",
    "periodicalTime",
  ],
  data() {
    return {
      searchStr: "",
    };
  },
  filters: {
    tipsFilter(type) {
      switch (type) {
        case 0:
          return "期刊论文";
        case 1:
          return "会议论文";
      }
    },
    tipsClassFilter(type) {
      switch (type) {
        case 0:
          return "tips-box periodical";
        case 1:
          return "tips-box meeting";
      }
    },
  },
  computed: {
    // highLightTitle() {
    //   return this.title.replaceAll(
    //     this.searchStr,
    //     `<span style="color:#517EF2">${this.searchStr}</span>`
    //   );
    // },
    /*
    highLightArtSummary() {
      return this.artSummary.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
   
    highLightAuthor() {
      return this.author.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    highLightOtherAuthor() {
      return this.otherAuthor.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
     */
    // highLightPeriodicalName() {
    //   if (this.periodicalName) {
    //     if (this.type === 0) {
    //       return this.periodicalName.replaceAll(
    //         this.searchStr,
    //         `<span style="color:#517EF2">${this.searchStr}</span>`
    //       );
    //     } else {
    //       return this.periodicalName;
    //     }
    //   } else {
    //     return "";
    //   }
    // },
    /*
    highLightPeriodicalTime() {
      return this.periodicalTime.replaceAll(
        this.searchStr,
        `<span style="color:#517EF2">${this.searchStr}</span>`
      );
    },
    */
  },
  created() {
    // this.searchStr = this.$route.query.paramStr;
  },
};
</script>

<style scoped lang="scss">
.lv-item-box {
  margin-top: 15px;
  padding-bottom: 15px;
  // .tips-box {
  //   display: none;
  // }
  .title-box {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 24px;
    h3 {
      font-size: 16px;
      color: #333333;
    }
    .tips-box {
      float: left;
      line-height: 20px;
      margin-right: 5px;
      padding: 1px 3px;
      border-radius: 3px;
      font-size: 12px;
      vertical-align: middle;
    }
    .periodical {
      background-color: #ffefda;
      color: #fea736;
    }
    .meeting {
      background-color: #e9efff;
      color: #4a79f1;
    }
  }
  .lv-item-artSummary {
    margin-top: 12px;
    font-size: 13px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .lv-item-content {
    display: flex;
    align-items: center;
    margin-top: 15px;
    font-size: 12px;
    color: #999999;
    .lv-item-author,
    .lv-item-periodicalTime,
    .lv-item-periodicalName {
      margin-right: 12px;
      // vertical-align: middle;
    }
    .lv-item-author {
      display: flex;
      align-content: center;
      .author {
        display: inline-block;
        max-width: 60px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .lv-item-periodicalName {
      display: inline-block;
      max-width: 84px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
</style>
